<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>新建员工费用</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;justify-content: space-between">
      <div style="width: 20%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            @node-click="handleNodeClick"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="filterNode"
            ref="tree"
          >
          </el-tree>
        </div>
      </div>
      <div>
        <el-table :data="selectEmployeeList"
                  fit border stripe="stripe"
                  ref="userTable"
                  height="700px"
                  :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                  :row-style="{height: '0'}"
                  @row-click="selectUser"
                  :cell-style="selectUserStateColor">
          <el-table-column
            align="center"
            prop="userName"
            width="50">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteSelectUser(scope.$index, selectEmployeeList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="orgName"
            label="所属门店" width="100px">
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="员工名称" width="100px">
          </el-table-column>
        </el-table>
      </div>
      <div class="table_container" style="border: 0 solid rgb(222,222,222);">
        <el-button size="mini"  @click="addSubsidyListMethod">添加一行</el-button>
        <el-table :data="subsidyList" fit border stripe="stripe"
                  height="500px" :cell-style="{padding: '5px'}"
                  :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            prop="userName"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteCost(scope.$index, subsidyList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="月份" width="200px">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.costDate"
                type="month"
                size="mini"
                style="width: 150px;"
                value-format="yyyy-MM"
              >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="类目" width="160px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.costId" clearable value filterable
                         style="width: 120px" size="mini" >
                <el-option
                  v-for="orgCost in orgCostList"
                  :key="orgCost.costId"
                  :label="orgCost.costCnName"
                  :value="orgCost.costId">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="money"
            label="金额/天数">
            <template slot-scope="scope">
              <el-input v-model="scope.row.money" onkeyup="value=value.replace(/[^\d.]/g,'')" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.comment" size="mini"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <span class="dialog-footer">
          <el-button size="mini" @click="closeUserSubsidyDialog">返 回</el-button>
          <el-button size="mini" @click="createUserSubsidy">确 定</el-button>
        </span>
      </div>
    </div>
    <el-dialog
      title="选择人员"
      :visible.sync="userDialogVisible"
      width="50%"
      style="position: absolute"
      @close="closeUserDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-input v-model="searchText" size="mini" style="width: 75%"></el-input>
      <el-button size="mini"  @click="loadUser" style="width: 20%">查询</el-button>
      <el-table :data="userList"
                fit border stripe="stripe"
                height="500px"
                :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                :row-style="{height: '0'}"
                :cell-style="orderStateColor"
                @selection-change="handleSelectionChangeDialog">
        <el-table-column
          type="selection"
          width="50">
        </el-table-column>
        <el-table-column
          align="center"
          prop="orgName"
          label="所属门店">
        </el-table-column>
        <el-table-column
          align="center"
          prop="userName"
          label="员工名称">
        </el-table-column>
      </el-table>
      <el-button size="mini" @click="closeUserDialog">确 定</el-button>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data(){
    return{
      userName:'',
      orgId: '',
      userId:'',
      authorities:'',
      filterText:'',
      orgList:[],
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      selectEmployeeList:[],
      selectedUser:'',
      userList:[],
      subsidyList:[],
      orgCostList:[],
      total:0,
      searchText:'',
      selectedAreaId:0,
      userCost:{
        userList:[],
        creator:'',
        createName:'',
        subsidyList:[],
      },
      search:'',
      userDialogVisible:false,
      selectTempEmployeeList:[],
    }
  },
  methods:{
    showUserDialog(){
      this.userDialogVisible = true;
    },
    closeUserDialog(){
      if (this.selectEmployeeList.length == 0){
        this.selectEmployeeList = this.selectTempEmployeeList;
      }
      if(this.selectTempEmployeeList.length>0 && this.selectEmployeeList.length > 0){
        this.selectTempEmployeeList.map((item) => {
          if (!this.selectEmployeeList.includes(item)){
            this.selectEmployeeList.push(item)
          }
        })
      }
      this.userDialogVisible = false;
    },
    handleSelectionChangeDialog(val){
      this.selectTempEmployeeList = val;
    },
    selectUserStateColor({row,columnIndex}){
      let include=0;
      this.selectEmployeeList.map((item) => {
        if(item.id == row.id){
          include ++;
        }
      })

      if (include > 1 && columnIndex ===1){
        return 'color: red';
      }
      if (include > 1 && columnIndex ===2){
        return 'color: red';
      }
    },
    orderStateColor({row,columnIndex}){
      let include=0;
      this.userList.map((item) => {
        if(item.id == row.id){
          include ++;
        }
      })

      if (include > 1 && columnIndex ===1){
        return 'color: red';
      }
      if (include > 1 && columnIndex ===2){
        return 'color: red';
      }
    },
    async selectUser(row){
      this.selectedUser = row;
    },
    // handleSelectionChange(val){
    //   if(val.length > 0){
    //     this.selectEmployeeList = val;
    //   }
    //   // if(val.length == 0){
    //   //   this.$nextTick(() => {
    //   //     this.selectEmployeeList.map((item)=>{
    //   //       this.userList.map((userItem)=>{
    //   //         if (item.id == userItem.id){
    //   //           this.$refs.userTable.toggleRowSelection(userItem)
    //   //         }
    //   //       })
    //   //     })
    //   //   })
    //   // }
    // },
    async handleNodeClick(data) {
      this.subsidyList = [];
      this.selectedAreaId = data.id;
      this.searchText = '';
      this.showUserDialog();
      await this.loadUser(data.id);
      await this.loadOrgCost(data.id);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    async loadOrg(){
      const {data:res} = await this.$http.get(`/orgs/areaList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    async loadUser(){
      const {data:res} = await this.$http.post('/load/org/employee',{areaId: this.selectedAreaId,
        searchText: this.searchText});
      this.userList = res.data;
    },
    addSubsidyListMethod(){
      let currentDate = this.getCurrentDate();
      let userCost = {
        costDate: currentDate,
        money:'',
        costId:'',
        comment:'',
      }
      if(this.subsidyList.length < this.total){
        this.subsidyList.push(userCost);
      }
    },
    async loadOrgCost(orgId){
      const {data:res} = await this.$http.get(`/cost/orgId/${orgId}/costType/${2}`);
      this.orgCostList = res.data;
      this.total = this.orgCostList.length;
    },
    //获取系统当前日期
    getCurrentDate() {
      let date = new Date(new Date().getTime());
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month
      return year + '-' + month;
    },
    async createUserSubsidy(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      if (this.selectEmployeeList.length === 0){
        this.$message.warning("请选择员工！");
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }
      this.userCost.userList = this.selectEmployeeList;
      this.userCost.subsidyList = this.subsidyList;
      this.userCost.creator = this.userId;
      this.userCost.createName = this.userName;
      const {data:res} = await this.$http.post(`/cost/addUserCost`, this.userCost);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeUserSubsidyDialog();
    },
    closeUserSubsidyDialog(){
      this.$router.go(-1);
    },
    deleteCost(index,rows){
      rows.splice(index, 1);
    },
    deleteSelectUser(index,rows){
      rows.splice(index, 1);
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.userName = window.sessionStorage.getItem("userName");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_con{
  height: 100%;
  overflow-y: auto;
  flex: 1;
  margin: 10px 0;
  /*border: 1px solid;*/
}
.table_container{
  width: 80%;
  flex: 4;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.outside_con{
  height: 250px;
}
.dialog-footer{
  display: flex;
  margin-top: 50px;
  //margin: 10px 10px;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/NewEmployeeCost.vue